export const DocumentActionTypes = {
  ADD_IMAGE_TO_DOCUMENT: `@DOCUMENT/ADD_IMAGE_TO_DOCUMENT`,
}
